import classNames from "classnames";
import React, { FC } from "react";
import { styles } from "./views.scss";


export const Viewer: FC<{
    fit?: boolean;
    children: React.ReactNode;
}> =
    ({ fit, children }) =>
    {
        return (
            <div className={classNames(styles.viewer, fit && styles.fit)}>
                {children}
            </div>
        );
    };